import { createSlice } from "@reduxjs/toolkit";

export const commonSlice = createSlice({
  name: "common",
  initialState: {
    formType: "createAccount",
    isModalOpen: false,
    userMobileNumber: "",
    token: localStorage.getItem("token"),
    // filteredGuide: [],
    // activeGuide: {},
    userInfo: {},
    isLoggedIn: false,
    isMiniDashboardOpen: false,
    formProps: {},
    isGuidePlatformCloseManually: false,
    refreshcontent: 0,
  },
  reducers: {
    setCurrentForm: (state, action) => {
      state.formType = action.payload;
    },
    setModalOpen: (state, action) => {
      state.isModalOpen = action.payload;
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
    setMobileNumber: (state, action) => {
      state.userMobileNumber = action.payload;
    },
    setIsLoggedIn: (state, action) => {
      state.isLoggedIn = action.payload;
    },
    setUserInfo: (state, action) => {
      state.userInfo = action.payload;
    },
    setGuidePlatformCloseManually: (state, action) => {
      state.isGuidePlatformCloseManually = action.payload;
    },
    // setFilteredGuide: (state, action) => {
    //   state.filteredGuide = action.payload;
    // },
    // setCurrentGuide: (state, action) => {
    //   state.activeGuide = action.payload;
    // },
    setIsMiniDashboardOpen: (state, action) => {
      state.isMiniDashboardOpen = action.payload;
    },
    setFormProps: (state, action) => {
      state.formProps = action.payload;
    },
    refreshContent: (state, action) => {
      state.refreshcontent = state.refreshcontent + 1;
    },
  },
  selectors: {
    getCurrentForm: (state) => state.formType,
    getIsModalOpen: (state) => state.isModalOpen,
    getToken: (state) => state.token,
    getUserMobileNumber: (state) => state.userMobileNumber,
    getIsLoggedIn: (state) => state.isLoggedIn,
    getUserInfo: (state) => state.userInfo,
    // getFilteredGuide: (state) => state.filteredGuide,
    // getActiveGuide: (state) => state.activeGuide,
    getIsMiniDashboardOpen: (state) => state.isMiniDashboardOpen,
    getFormProps: (state) => state.formProps,
    getGuidePlatformCloseManually: (state) => state.isGuidePlatformCloseManually,
  },
});

export const {
  setCurrentForm,
  setModalOpen,
  setToken,
  setMobileNumber,
  setIsLoggedIn,
  setUserInfo,
  // setFilteredGuide,
  // setCurrentGuide,
  setIsMiniDashboardOpen,
  setFormProps,
  setGuidePlatformCloseManually,
  refreshContent,
} = commonSlice.actions;
export const {
  getCurrentForm,
  getIsModalOpen,
  getToken,
  getUserMobileNumber,
  getIsLoggedIn,
  getUserInfo,
  // getFilteredGuide,
  // getActiveGuide,
  getIsMiniDashboardOpen,
  getFormProps,
  getGuidePlatformCloseManually,
} = commonSlice.selectors;
